module.exports = __webpack_public_path__ + "media/images/dropdown-1e87204d.png";